import React from 'react';

/**
 * Content for the Step 4 PMR self-upload List & Loop screens (#155514).
 */
export const pmrUploadDescription = (
  <p>
    Upload copies of your medical records to support your claim. These records
    may be from private medical providers, Vet Centers, or Community Care
    providers.
  </p>
);
